import { Component, OnInit } from '@angular/core';
import { GlobalMessageHandlerService } from '../../services/util/global-message-handler.service';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-global-message',
  standalone: true,
  templateUrl: './global-message.component.html',
  imports: [NgIf],
  styleUrls: ['./global-message.component.scss']
})
export class GlobalMessageComponent implements OnInit {
  errorMessage: string | null = null;
  successMessage: string | null = null;

  constructor(private globalMessageHandler: GlobalMessageHandlerService) {}

  ngOnInit(): void {
    // Subscribe to error messages from the service
    this.globalMessageHandler.errorMessages$.subscribe((message) => {
      this.errorMessage = message;
    });
    this.globalMessageHandler.successMessages$.subscribe((message) => {
      this.successMessage = message;
    });
  }

  closeErrorAlert(): void {
    this.errorMessage = null; // Close the error message
  }

  closeSuccessAlert(): void {
    this.successMessage = null; // Close the success message
  }
}
